import {
  CREATE_STRIPE_CONNECT_ACCOUNT,
  CHECK_STRIPE_CONNECT_STATUS,
  RESEND_STRIPE_CONNECT_LINK,
} from "../actions/stripeConnect.actions";

const initialState = {
  createAccountResponse: null,
  connectStatus: null,
  resendLinkResponse: null,
  isCreatingAccount: false,
  isCheckingStatus: false,
  isResendingLink: false,
};

export const stripeConnectReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_STRIPE_CONNECT_ACCOUNT.REQUEST:
      return {
        ...state,
        isCreatingAccount: true,
        createAccountResponse: null,
      };
    case CREATE_STRIPE_CONNECT_ACCOUNT.SUCCESS:
      return {
        ...state,
        isCreatingAccount: false,
        createAccountResponse: action.payload,
      };
    case CREATE_STRIPE_CONNECT_ACCOUNT.FAILURE:
      return {
        ...state,
        isCreatingAccount: false,
        createAccountResponse: null,
      };

    case CHECK_STRIPE_CONNECT_STATUS.REQUEST:
      return {
        ...state,
        isCheckingStatus: true,
        connectStatus: null,
      };
    case CHECK_STRIPE_CONNECT_STATUS.SUCCESS:
      return {
        ...state,
        isCheckingStatus: false,
        connectStatus: action.payload,
      };
    case CHECK_STRIPE_CONNECT_STATUS.FAILURE:
      return {
        ...state,
        isCheckingStatus: false,
        connectStatus: null,
      };

    case RESEND_STRIPE_CONNECT_LINK.REQUEST:
      return {
        ...state,
        isResendingLink: true,
        resendLinkResponse: null,
      };
    case RESEND_STRIPE_CONNECT_LINK.SUCCESS:
      return {
        ...state,
        isResendingLink: false,
        resendLinkResponse: action.payload,
      };
    case RESEND_STRIPE_CONNECT_LINK.FAILURE:
      return {
        ...state,
        isResendingLink: false,
        resendLinkResponse: null,
      };

    default:
      return state;
  }
}; 
